import React from 'react';
import './App.css';
import {PrimeReactProvider} from "primereact/api";
import {Provider} from "react-redux";
import {store} from "./store/store";
import {CustomRouter} from "./components/router";

import "../src/assets/css/App.css";
// import "./assets/css/Sidebar.scss";
import "primereact/resources/themes/md-dark-indigo/theme.css";
import {ThemeContextProvider} from "./view/widgets/app-wide/theme/theme_context_provider";
import {CssBaseline} from "@mui/material";
import {HelmetProvider} from "react-helmet-async";
// import '@fontsource/roboto/300.css';
// import '@fontsource/roboto/400.css';
// import '@fontsource/roboto/500.css';
// import '@fontsource/roboto/700.css';

// import "../src/assets/css/layout/layout.scss"

function App() {
    return (
        <ThemeContextProvider>
            <CssBaseline />
            <PrimeReactProvider>
                <Provider store={store}>
                    <HelmetProvider>
                        <CustomRouter/>
                    </HelmetProvider>
                </Provider>
            </PrimeReactProvider>
        </ThemeContextProvider>
    )
}

export default App;
